<template>
  <div class="row auctions artworks-list">
    <ArtworkRow v-for="(artwork, index) in artworks" :key="artwork.id"
                :artwork="artwork"
                :index="index" />
    <transition @beforeEnter="beforeEnterAnimation"
                @enter="enterAnimation"
                @leave="leaveAnimation"
                appear>
      <SearchResultsModal v-if="currentArtworkIndex !== ''"/>
    </transition>
  </div>
</template>

<script>
  /* eslint no-param-reassign: ["error", { "props": false }] */
  import IsIos from '@/shared/mixins/is_ios';
  import { mapGetters } from 'vuex';
  import ArtworkRow from './artwork_row';
  import SearchResultsModal from './modal/index';

  export default {
    name: 'ArtworksList',
    components: {
      ArtworkRow,
      SearchResultsModal,
    },
    mixins: [IsIos],
    computed: {
      ...mapGetters(['artworks', 'currentArtworkIndex']),
    },
    methods: {
      bodyClass() {
        if (this.isIos) {
          document.body.classList.add('ios-fix');
        } else {
          document.body.classList.add('modal-open');
        }
      },
      beforeEnterAnimation(el) {
        this.bodyClass();
        el.style.transform = 'translateY(-40%)';
        el.style.opacity = '0';
      },
      enterAnimation(el, done) {
        let round = -40;
        el.style.opacity = 1;

        const interval = setInterval(() => {
          el.style.transform = `translateY(${round}%)`;
          round += 1;
          if (round > 0) {
            clearInterval(interval);
            el.style.transform = '';
            done();
          }
        }, 3);
      },
      leaveAnimation(el, done) {
        let round = 0;
        let opacityProperty = 1;

        const interval = setInterval(() => {
          el.style.transform = `translateY(${round}%)`;
          el.style.opacity = opacityProperty;
          round -= 1;
          opacityProperty -= 0.025;
          if (round < -50) {
            clearInterval(interval);
            document.body.className = '';
            done();
          }
        }, 3);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/artworks_list.vue?0162970c